<template>
  <div>
    <div class="row ">
      <div class="col-lg-4">
        <div class="form-group">
          <label class="form-label d-flex">Dealership Name<span class="form-error">{{ validateErrors.first('Dealership Name') }}</span></label>
          <input name="Dealership Name" type="text" class="form-control" v-model.trim="lead.dealer_name" v-validate="'required'"
                 :readonly="isConfirmPage"/>
        </div>
        <div class="form-group">
          <label class="form-label d-flex">Address<span class="form-error">{{ validateErrors.first('Address') }}</span></label>
          <input name="Address" type="text" class="form-control" v-model.trim="lead.address1" v-validate="'required'" />
        </div>
        <div class="form-group">
          <label class="form-label">Address 2</label>
          <input name="Address2" type="text" class="form-control" v-model.trim="lead.address2" />
        </div>
        <div class="form-group ">
          <label class="form-label d-flex">City <span class="form-error">{{ validateErrors.first('City') }}</span></label>
          <input name="City" type="text" class="form-control" v-model.trim="lead.city" v-validate="'required'" />
        </div>
        <div class="form-group">
          <label class="form-label d-flex">State <span class="form-error">{{ validateErrors.first('State') }}</span></label>
          <b-form-select name="State" id="ddState" v-model.trim="lead.state" v-validate="'required'">
            <option v-for="(option, name) in stateOptions" :value="name">
              {{ name }} - {{ option }}
            </option>
          </b-form-select>
        </div>
        <div class="form-group">
          <label class="form-label d-flex">Zip<span class="form-error">{{ validateErrors.first('Zip') }}</span></label>
          <input name="Zip" type="text" class="form-control" v-model.trim="lead.zip" v-validate="{ required: true, regex: /^[0-9]{5}(?:-[0-9]{4})?$/ } " />
        </div>
      </div>
      <div class="col-lg-4">
        <div slot="header pb-3">
          <strong>New Vehicle Franchise Makes at Your Location</strong>
        </div>
        <span class="form-error"><label v-if="makesloading">Loading Make List...</label>{{ validateErrors.first('Makes') }}</span>

        <div style="max-height:48vh; overflow: auto;">
          <b-form-checkbox-group stacked :plain="true" v-model="lead.selected_makes" name="Makes"
                                 :checked="lead.selected_makes" v-validate="'required'">
            <b-form-checkbox v-for="m in lead.makes" :value="m.value" v-bind:key="m.ID">
              {{
                          m.text
              }}
            </b-form-checkbox>
          </b-form-checkbox-group>

        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label class="form-label d-flex">Phone Number<span class="form-error">{{ validateErrors.first('Phone Number') }}</span></label>
          <masked-input name="Phone Number" type="tel" class="form-control" v-model.trim="lead.phone"  v-validate="'required'" mask="(111) 111-1111" />
        </div>
        <div class="form-group">
          <label class="form-label d-flex">Contact Name <span class="form-error">{{ validateErrors.first('First Name') }}{{ validateErrors.first('Last Name') }}</span></label>
          <div class="row">
            <input name="First Name" type="text" class="form-control col" v-model.trim="lead.contact_firstname" v-validate="'required'" placeholder="First" />
            <input name="Last Name" type="text" class="form-control col" v-model.trim="lead.contact_lastname" v-validate="'required'" placeholder="Last" />
          </div>
        </div>
        <div class="form-group">
          <label class="form-label d-flex">Contact Position <span class="form-error">{{ validateErrors.first('Contact Position') }}</span></label>
          <input name="Contact Position" type="text" class="form-control" v-model.trim="lead.contact_position" v-validate="'required'" />
        </div>
        <div class="form-group">
          <label class="form-label d-flex">Contact Phone<span class="form-error">{{ validateErrors.first('Contact Phone') }}</span></label>
          <masked-input name="Contact Phone" type="tel" class="form-control" v-model.trim="lead.contact_phone" v-validate="'required'" mask="(111) 111-1111 x1111" />
        </div>
        <div class="form-group">
          <label class="form-label d-flex">Dealership URL<span class="form-error">{{ validateErrors.first('Dealership URL') }}</span></label>
          <input name="Dealership URL" type="text" class="form-control" v-model.trim="lead.dealer_url" v-validate="'required|url'" />
        </div>
        <div class="form-group">
          <label class="form-label d-flex">Contact Email<span class="form-error">{{ validateErrors.first('Contact Email') }}</span></label>
          <input name="Contact Email" type="email" class="form-control" v-model.trim="lead.contact_email" v-validate="'required|email'" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import VeeValidate from 'vee-validate'
import MaskedInput from 'vue-masked-input'
import axios from 'axios'

export default {
  data () {
    return {
      lead: {
        dealer_name: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        contact_firstname: '',
        contact_lastname: '',
        contact_position: '',
        contact_phone: '',
        dealer_url: '',
        contact_email: '',
        makes: {},
        selected_makes: []

      },
      makesloading: true,
      stateOptions: {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AS': 'American Samoa',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FM': 'Federated States Of Micronesia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'GU': 'Guam',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MH': 'Marshall Islands',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'MP': 'Northern Mariana Islands',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PW': 'Palau',
        'PA': 'Pennsylvania',
        'PR': 'Puerto Rico',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VI': 'Virgin Islands',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
      }
    }
  },
  components: {
    MaskedInput
  },
  inject: ['$validator'],
  props: {
    isConfirmPage: Boolean
  },
  created () {
    var self = this
    if (!this.$props.isConfirmPage) { this.$props.isConfirmPage = false }
    // get all makes
    axios.get('/api/vehicleequipment/getallmakes')
      .then(response => {
        // console.log(JSON.stringify(response))
        this.makesloading = false
        this.lead.makes = response.data.makes
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
  }

}
</script>

<style scoped>
  .form-error{
    margin-left: auto;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/DealerInformation.vue